import { ReactElement, ReactNode, Children } from 'react';

interface GridHeaderProps {
  children: ReactNode;
  className?: string;
}

export default function GridHeader({ children, className = '' }: GridHeaderProps): ReactElement {
  // Count the number of valid child elements
  const childCount = Children.count(children);

  return (
    <div
      className={`cr-col-span-${childCount} cr-rounded-b-0 cr-grid 
                  cr-grid-cols-subgrid cr-rounded-t-lg cr-border-2 cr-border-solid cr-border-cirrusBlue-100 
                  cr-bg-cirrusBlue-50 cr-p-3
                  cr-font-main cr-text-sm cr-text-blue-900 md:cr-text-base ${className}`}
    >
      {children}
    </div>
  );
}
